import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import rootReducer from "./redux/reducers";
import thunk from "redux-thunk";
const reduxStore = createStore(rootReducer, applyMiddleware(thunk));

ReactDOM.render(
  <Suspense fallback={<div>Loading</div>}>
    {/* <React.StrictMode> */}
    <Provider store={reduxStore}>
      <App />
    </Provider>
    {/* </React.StrictMode> */}
  </Suspense>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
